import { styled, TextArea } from '@ltvco/refresh-lib/theme';

export const StyledTextArea = styled(TextArea)(() => ({
  height: '136px',

  '&.MuiTextField-root > div ': {
    height: '136px',
    overflow: 'auto',
    position: 'static',
  },

  '.MuiOutlinedInput-root': {
    alignItems: 'baseline',
  },
}));
